import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import {
  aerialDrops,
  dropBurry,
  fulfillmentServicesExpertise,
  fulfillmentServicesHeroSection,
  installation,
  MDU,
  stormRestoration,
  troubleCalls,
} from 'images/expertise/fulfillment-services';
import { FulfillmentBlock } from '../containers/expertise';
import { Box } from '@material-ui/core';

const FulfillmentServices: NextPage = () => {
  return (
    <>
      <Header
        title="Fulfillment Services"
        description="Utilities One provides a complete range of fulfillment services to meet the connectivity needs of residential and commercial customers.
From installation to troubleshooting and storm recovery, we ensure that your internet and cable systems work reliably every step of the way."
        image={fulfillmentServicesExpertise}
      />
      <FulfillmentBlock
        title={'Installation'}
        image={installation}
        description={
          'We provide expert installation for copper, fiber, and coaxial systems, covering streaming, TV, VOIP, and internet services. With extensive project experience, our team ensures smooth setup and optimized connections for each property.'
        }
      />
      <FulfillmentBlock
        title={'Drop Bury'}
        image={dropBurry}
        description={
          'Our Drop Bury service secures cables underground at the appropriate depth using conduit, driveway boring, sidewalk boring, and pull-through techniques. This protects your connection from wear, providing long-lasting, reliable service with minimal disruption to your property.'
        }
        isImageLeft
      />
      <FulfillmentBlock
        title={'Aerial Drops'}
        image={aerialDrops}
        description={
          'Our aerial drop service ensures reliable, secure, and weather-resistant overhead cable placement. We install various lengths of coaxial and fiber cables following industry standards, ensuring dependable service for both residential and commercial clients.'
        }
      />
      <FulfillmentBlock
        title={'MDU '}
        subTitle={'(Multiple Dwelling Units)'}
        image={MDU}
        description={
          'Our team specializes in internet and cable systems for apartments, offices, and other multi-unit buildings. With structured cabling, we provide fast, reliable solutions for each unit, with minimal disruption during installations or upgrades.'
        }
        isImageLeft
      />
      <FulfillmentBlock
        title={'Trouble Calls'}
        image={troubleCalls}
        description={
          'Our team quickly handles connectivity issues for homes and businesses using provider-approved, advanced meters to diagnose signal problems. We work efficiently to minimize downtime and restore your connection as soon as possible.'
        }
      />
      <FulfillmentBlock
        title={'Storm Restoration'}
        image={stormRestoration}
        description={
          'Our Tiger Storm Restoration team is ready to act fast when severe weather affects your service.\n' +
          'We assess the damage and make all necessary repairs, getting homes and businesses nationwide back online quickly and effectively.'
        }
        isImageLeft
      />
      <Box mt={15} />
    </>
  );
};

export default FulfillmentServices;
